<div class="svg-container" [innerHTML]="sanitizedSvgContent" [ngStyle]="{ height: height}"></div>